import React from 'react'

type AppProps={
    subHeading:string;
}



const DetailedSubHeader = ({subHeading}:AppProps) => {
  return (
    <div>
        <div className='grouping-sub-headers mt-2'>{subHeading}</div>
    </div>
  )
}

export default DetailedSubHeader